import React from 'react';
import { logoNav } from '../configs/src_routes.ts';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import routes from '../configs/routes.ts';

const Nav = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className='nav-pad'>
      <div className='nav-container'>
        <div className='nav-logo-wrap' onClick={() =>navigate(routes.default)}>
          <img src={logoNav} alt='logo' />
        </div>
        <div className='nav-menu-wrap'>
          <div className='nav-menu' onClick={() =>navigate(routes.about)}>{t('About')}</div>
          <div className='nav-menu' onClick={() =>navigate(routes.contact)}>{t('Contact')}</div>
        </div>
      </div>
    </div>
  );
};

export default Nav;